<template>
  <div class="lxm-row box is-clearfix" @click="clicked">
    <span class="lxm-row__left" :class="{ 'lxm-row__left--has-icon': iconClass }">
      <template v-if="iconClass">
        <i :class="iconClass"></i>
      </template>
      <span v-html="name"></span>
    </span>
    <span v-if="$slots.default" class="lxm-row__value" :class="siteClass">
      <slot></slot>
    </span>
    <div v-if="$slots.content || image" class="lxm-row__content content">
      <p>
        <img v-if="image" class="lxm-row__content-image" :src="image" />
        <slot name="content"></slot>
      </p>
    </div>

    <template v-if="mobileCheck">
      <div style="text-align: right;">
        <span class="lxm-row__right" :class="{ 'lxm-row__left--has-icon': iconMobileClass }">
          <template v-if="iconMobileClass">
            <i :class="iconMobileClass"></i>
          </template>
          {{ mobileCheck }}
        </span>
      </div>
    </template>
  </div>
</template>

<style lang="stylus" scoped>
  @import '../../styles/index.styl'
  icon-width = siz(20)
  .lxm-row
    font-size: size
    &.box
      padding: spacing
      &:not(:last-child)
        margin-bottom: spacing
  .lxm-row__left
    display: inline-block
    line-height: 1
  .lxm-row__left--has-icon
    padding-left: icon-width
    position: relative
  .lxm-row__value
    color: grey-dark
  .lxm-row__content
    color: grey-dark
    margin-top: spacing
  .lxm-row__content-image
    width: 100%

  .lxm-row__img-icon
    display: inline-block
    vertical-align: top
    background-size: 100% 100%
    position: absolute
    top: 0
    left: 0
    width: icon-width
    height: 100%
    background-position: left center
    background-repeat: no-repeat
  .lxm-row__img-icon--cf-money
    background-size: siz(12.5) siz(12.5)
    background-image: url(../../images/main/cf/money.png)
  .lxm-row__img-icon--cf-status
    background-size: siz(12.5) siz(12.5)
    background-image: url(../../images/main/cf/status.png)
  .lxm-row__img-icon--cf-phone
    background-size: siz(9.5) siz(14)
    background-image: url(../../images/main/cf/phone.png)
  .lxm-row__img-icon--cf-mail
    background-size: siz(13.5) siz(11)
    background-image: url(../../images/main/cf/mail.png)

  .lxm-row__img-icon--cf-success
    background-size: siz(12.5) siz(12.5)
    background-image: url(../../images/main/cf/success.png)

  .lxm-row__img-icon--main-close
    background-size: siz(12.5) siz(12.5)
    background-image: url(../../images/main/close.png)

  .lxm-row__img-icon--form-name
    background-size: siz(14) siz(13)
    background-image: url(../../images/main/form/name.png)
  .lxm-row__img-icon--form-mail
    background-size: siz(13.5) siz(11)
    background-image: url(../../images/main/form/mail.png)
  .lxm-row__img-icon--form-phone
    background-size: siz(9.5) siz(14)
    background-image: url(../../images/main/form/phone.png)
  .lxm-row__img-icon--form-org
    background-size: siz(14) siz(14)
    background-image: url(../../images/main/form/org.png)
  .lxm-row__img-icon--form-comment
    background-size: siz(12) siz(12.5)
    background-image: url(../../images/main/form/comment.png)
  .lxm-row__img-icon--form-source
    background-size: siz(13) siz(12.5)
    background-image: url(../../images/main/form/source.png)
  .lxm-row__img-icon--form-bracket
    background-size: siz(13) siz(12.5)
    background-image: url(../../images/main/form/bracket.png)
  .lxm-row__img-icon--form-datetime
    background-size: siz(15) siz(14.5)
    background-image: url(../../images/main/form/datetime.png)
</style>

<script>
  export default {
    props: {
      iconClass: String,
      iconMobileClass: String,
      mobileCheck: String,
      valueSite: String,
      name: { type: String, default: '' },
      href: String,
      image: String
    },
    computed: {
      siteClass: function () {
        return this.valueSite === 'left' ? '' : 'is-pulled-right'
      }
    },
    methods: {
      clicked () {
        this.$emit('click')
        if (this.href) {
          window.open(this.href)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// LxmRow.vue?2f6ca157